import { FC } from "react";

import { RouterProvider } from "react-router-dom";
import { ATLAS_ROUTER } from "@/app/router/constants";

interface AppRouterProps {}

export const AtlasRouter: FC<AppRouterProps> = () => {
  return <RouterProvider router={ATLAS_ROUTER} />;
};
